// export type TPurchaseHistoryResponse = {
//   id: string;
//   paid_amount: number;
//   pay_type: number;
//   pay_date: number;
//   product_type: number;
//   subscription: TSubscription;
//   price: TPriceData;
//   sku: TSku;
// };

// export type TPriceData = {
//   currency: string;
//   price: number;
// };

// export type TSku = {
//   data_retention_days: number;
//   id: number;
//   name: string;
//   subscription_cycle: number;
// };

// export type TSubscription = {
//   next_billing_date: number;
//   end_date: number;
//   start_date: number;
//   status: SUBSCRIPTION_STATUS;
// };

export enum SUBSCRIPTION_STATUS {
  INITIAL = 'Initial',
  PAYFAILED = 'PayFailed',
  SUBSCRIBED = 'Subscribed',
  CANCELLED = 'Cancelled',
  EXPIRED = 'Expired',
  RENEWFAILED = 'RenewFailed'
}

// export type TTransaction = {
//   currency: string;
//   id: string;
//   paid_amount: number;
//   refund_info: TRefundInfo;
//   refund_transaction_id: string;
//   status: TRANSACTION_STATUS;
//   transaction_id: string;
//   transaction_time: number;
// };

export type TTransactionList = {
  items: TTransaction[];
  next_page: string;
  total_count: number;
};

export type TTransaction = {
  id: string;
  transaction_time: number;
  currency: string;
  amount: number;
  status: string;
  renew_count: number;
  sku_name: string;
};

export type TTransactionState = {
  invoices: TTransaction[];
  isLoading: boolean;
  totalCount: number;
};

export type TInvoiceListV2 = {
  items: TInvoiceV2[];
  next_page: string;
  total_count: number;
};

export type TInvoiceV2 = {
  id: string;
  currency: string;
  amount: number;
  status: string;
  renew_count: number;
  sku_id: string;
  user_id: string;
  transaction_time: Date;
  sku_name: string;
  managed_by: string;
  subscription_id: string;
};

export type TInvoiceStateV2 = {
  invoices: TInvoiceV2[];
  isLoading: boolean;
  totalCount: number;
};

// export type TPurchaseHistoryInitialState = {
//   purchaseHistory: TPurchaseHistoryResponse[];
//   selectedPurchaseId: string;
//   transactionList: TTransaction[];
//   isLoading: boolean;
// };
export enum TRANSACTION_STATUS {
  SUCCESS = 'success',
  FAILED = 'failed',
  REFUND = 'refund'
}

// export type TRefundInfo = {
//   reason: string;
// };

export enum SUBSCRIPTION_TYPE {
  PREVIEW = 'Preview',
  TRIAL = 'Trial',
  PAID = 'Paid'
}

export enum SUBSCRIPTION_SKUS {
  SOLO_SECURITY = 'Solo Security',
  ENHANCED_SECURITY = 'Enhanced Security',
  PREMIUM_SECURITY = 'Premium Security'
}
